define('collections/calendar/nutrition/servings',[
    'underscore', 'backbone', 'utils',
    // models
    'models/calendar/nutrition/serving'
], function(
    // libs
    _, Backbone, U,
    // model
    MServing
) {

    var CServings = Backbone.Collection.extend({
        model: MServing,
    });

    return CServings;
});

